/**
 * An all-in-one button component including the various wrap options.
 * Use this for most CTAs
 *
 */

import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

// Primitives
import WrapRotation from "./WrapRotation";
import WrapMouseMove from "./WrapMouseMove";
import WrapButton from "./WrapButton";
import WrapLink from "./WrapLink";
import WrapArrow from "./WrapArrow";

const Button = ({
  className,
  children,
  clickFunction,
  color,
  externalLink,
  href,
  arrows,
  size,
  type,
}) => {
  return (
    <WrapRotation
      className="inline-block"
      // introDelay={0.2}
      // introDirection="fromLeft"
    >
      <WrapMouseMove>
        {/* If it's a link, use Link component, otherwise a button */}
        {href ? (
          <WrapLink
            className={classNames(
              size === "sm" && "text-sm",
              size === "md" && "text-md",
              size === "lg" && "text-lg",
              size === "xl" && "text-xl",
              size === "2xl" && "text-2xl",
              size === "3xl" && "text-3xl",
              size === "4xl" && "text-4xl",
              className
            )}
            color={color}
            href={href}
            externalLink={externalLink}
          >
            {arrows && <WrapArrow direction="right" />}
            {children}
            {arrows && <WrapArrow direction="left" />}
          </WrapLink>
        ) : (
          <WrapButton
            className={classNames(
              size === "sm" && "text-sm",
              size === "md" && "text-md",
              size === "lg" && "text-lg",
              size === "xl" && "text-xl",
              size === "2xl" && "text-2xl",
              size === "3xl" && "text-3xl",
              size === "4xl" && "text-4xl",
              className
            )}
            color={color}
            clickFunction={clickFunction}
            type={type}
          >
            {arrows && <WrapArrow direction="right" />}
            {children}
            {arrows && <WrapArrow direction="left" />}
          </WrapButton>
        )}
      </WrapMouseMove>
    </WrapRotation>
  );
};

Button.defaultProps = {
  arrows: false,
  type: "button",
  size: "lg",
};

Button.propTypes = {
  /** Set "arrows" to show a left and right arrow around text */
  arrows: PropTypes.bool,
  /** Extra classnames for styling */
  className: PropTypes.string,
  /** If an external link, set this to true */
  externalLink: PropTypes.bool,
  /** Pass in an optional function. This will be overridden if href is set */
  clickFunction: PropTypes.func,
  /** black (default), green */
  color: PropTypes.string,
  children: PropTypes.node,
  /** href */
  href: PropTypes.string,
  /** (font) size. sm, md, lg (default), xl, 2xl, 3xl, 4xl */
  size: PropTypes.string,
  /** type. default = button */
  type: PropTypes.string,
};

export default Button;
